var hotelPageTitleTemplate = require('templates/hotelPageTitle.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'hotelPageTitle',
  template: {
    'hotelPageTitle': hotelPageTitleTemplate
  }
});
